import { render, staticRenderFns } from "./PriceCaculator.vue?vue&type=template&id=5630c36a&scoped=true&"
import script from "./PriceCaculator.vue?vue&type=script&lang=js&"
export * from "./PriceCaculator.vue?vue&type=script&lang=js&"
import style0 from "./PriceCaculator.vue?vue&type=style&index=0&id=5630c36a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5630c36a",
  null
  
)

export default component.exports